import { Action } from 'redux';
import { VideoWatchHistoryInterface } from './watch-history';
import * as VideoWatchHistoryAction from './watch-history.actions';

export interface WatchHistoryState {
    watchHistory: Array<VideoWatchHistoryInterface>;
}

const initialState: WatchHistoryState = {
    watchHistory: null
};

export const WatchHistoryReducer =
    function (state: WatchHistoryState = initialState, action: Action): WatchHistoryState {
        switch (action.type) {
            case VideoWatchHistoryAction.READ:
                const watchHistory: Array<VideoWatchHistoryInterface> = (<VideoWatchHistoryAction.READAction>action).watchHistory;
                return {
                    watchHistory: watchHistory
                };
            case VideoWatchHistoryAction.CLEAR:
                return {
                    watchHistory: []
                };
            default:
                return state;
        }
    };

export const getWatchHistoryState = (state): WatchHistoryState => state.users;

// export const getCurrentUser = createSelector(
//     getUsersState,
//     (state: UsersState) => state.currentUser);

